// following is my AuthContext code: after login if user selected remeber me and comes back again to this page later if the remeber me is turned on it will redirect directly to whatver page it is sendijg to after succesfull login
// src/auth/JWTAuthContext.js
import { createContext, useEffect, useReducer } from "react";
import axios from "axios";
import { MatxLoading } from "app/components";
import { API_BASE } from "app/config/api";

const initialState = {
  user: null,
  isInitialized: false,
  isAuthenticated: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialized: true, user };
    }
    case "LOGIN": {
      return { ...state, isAuthenticated: true, user: action.payload.user };
    }
    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }
    case "REGISTER": {
      return { ...state, isAuthenticated: true, user: action.payload.user };
    }
    case "UPDATE_USER": {
      return { ...state, user: action.payload.user };
    }
    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  login: () => Promise.resolve(),
  logout: () => {},
  register: () => Promise.resolve(),
  updateUser: () => {}
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE}/admin/login`, { email, password });
      const { token } = response.data;
      const admin = response.data.admin ? response.data.admin : {
        _id: response.data.adminId,
        username: response.data.admin_username,
        email: response.data.email,
        image: response.data.profile_pic,
        role: "ADMIN"
      };

      // Store user and token in local storage
      localStorage.setItem("user", JSON.stringify(admin));
      localStorage.setItem("token", token);

      // Set default authorization header
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // Dispatch login action
      dispatch({ type: "LOGIN", payload: { user: admin } });
    } catch (error) {
      console.error("Login error:", error);
      alert("Login failed: " + (error.response ? error.response.data.message : error.message));
    }
  };

  const register = async (email, username, password) => {
    try {
      const response = await axios.post("/api/auth/register", { email, username, password });
      const { user, token } = response.data;

      // Store user and token in local storage
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);

      // Set default authorization header
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // Dispatch register action
      dispatch({ type: "REGISTER", payload: { user } });
    } catch (error) {
      console.error("Registration error:", error);
      alert(
        "Registration failed: " + (error.response ? error.response.data.message : error.message)
      );
    }
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
    dispatch({ type: "LOGOUT" });
  };

  // Merge updates into the current admin user (e.g. after a profile-photo change)
  const updateUser = (updates) => {
    const stored = localStorage.getItem("user");
    const current = stored && stored !== "undefined" ? JSON.parse(stored) : {};
    const user = { ...current, ...updates };
    localStorage.setItem("user", JSON.stringify(user));
    dispatch({ type: "UPDATE_USER", payload: { user } });
  };

  useEffect(() => {
    const initialize = () => {
      try {
        const token = localStorage.getItem("token");
        const userStr = localStorage.getItem("user");
        const user = userStr && userStr !== "undefined" ? JSON.parse(userStr) : null;

        if (token && user) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          dispatch({ type: "INIT", payload: { isAuthenticated: true, user } });
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          dispatch({ type: "INIT", payload: { isAuthenticated: false, user: null } });
        }
      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        dispatch({ type: "INIT", payload: { isAuthenticated: false, user: null } });
      }
    };

    initialize();
  }, []);

  if (!state.isInitialized) return <MatxLoading />;

  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", login, logout, register, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
